webpackJsonp([7],{

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(294);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127255f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(336);
function injectStyle (ssrContext) {
  __webpack_require__(329)
}
var normalizeComponent = __webpack_require__(118)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-127255f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127255f0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThemeSwitcher__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProfileLink__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LanguageSelectorComponent__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Footer__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CookiePolicyBanner__ = __webpack_require__(284);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var messages = {
  en: {
    message: {
      pollscapeLogoText: 'Pollscape logo',
      pageSubTitle: 'Create, share and vote. All of it in real-time!',
      pollscapeDesc: 'Pollscape is a simple polling app that allows you to create polls, share them with your friends and get opinions in real-time'
    }
  },
  hi: {
    message: {
      pollscapeLogoText: 'पोलस्केप लोगो',
      pageSubTitle: 'बनाएं, साझा करें और वोट दें। यह सब वास्तविक समय में!',
      pollscapeDesc: 'Pollscape एक मतदान ऐप है जो आपको चुनाव बनाने, उन्हें अपने दोस्तों के साथ साझा करने और वास्तविक समय में राय प्राप्त करने में सहायता करता है'
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: typeof Storage !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
  messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: i18n,
  components: {
    themeSwitcher: __WEBPACK_IMPORTED_MODULE_2__ThemeSwitcher__["a" /* default */],
    profileLink: __WEBPACK_IMPORTED_MODULE_3__ProfileLink__["a" /* default */],
    languageSelector: __WEBPACK_IMPORTED_MODULE_4__LanguageSelectorComponent__["a" /* default */],
    footerComponent: __WEBPACK_IMPORTED_MODULE_5__Footer__["a" /* default */],
    cookiePolicyBanner: __WEBPACK_IMPORTED_MODULE_6__CookiePolicyBanner__["a" /* default */]
  },
  data: function data() {
    return {
      userLocale: i18n.locale,
      iconTheme: this.getIconTheme()
    };
  },

  methods: {
    getIconTheme: function getIconTheme() {
      var currentTheme = typeof Storage !== 'undefined' ? localStorage.getItem('theme') ? localStorage.getItem('theme') : 'light' : 'light';
      return currentTheme ? currentTheme === 'dark' ? 'light' : 'dark' : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'light' : 'dark';
    },
    setIconTheme: function setIconTheme(theme) {
      this.iconTheme = theme === 'light' ? 'dark' : 'light';
    },
    setLanguage: function setLanguage(lang) {
      if (lang === 'en') {
        i18n.locale = 'en';
      } else if (lang === 'hi') {
        i18n.locale = 'hi';
      }
      this.userLocale = i18n.locale;
    }
  },
  mounted: function mounted() {
    document.title = 'Pollscape';
  }
});

/***/ }),

/***/ 329:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('nav',{staticClass:"mdl-navigation"},[_c('div',{staticClass:"mdl-layout-spacer"}),_vm._v(" "),_c('theme-switcher',{attrs:{"iconTheme":_vm.iconTheme,"userLang":_vm.userLocale},on:{"themeChanged":function($event){return _vm.setIconTheme($event)}}}),_vm._v(" "),_c('profile-link',{attrs:{"theme":_vm.iconTheme,"userLang":_vm.userLocale}}),_vm._v(" "),_c('language-selector',{attrs:{"borderColor":_vm.iconTheme === 'dark' ? '#000000' : '#FFFFFF',"backgroundColor":_vm.iconTheme === 'dark' ? '#FFFFFF' : '#000000'},on:{"languageChanged":function($event){return _vm.setLanguage($event)}}})],1),_vm._v(" "),_c('section',{staticClass:"mdl-grid header-background"},[_c('div',{staticClass:"mdl-cell mdl-cell--5-col mdl-cell--3-col-tablet mdl-cell--1-col-phone logo-container"},[_c('img',{staticClass:"pollscape-logo",attrs:{"src":"static/img/icons/ic_pollscape_192x192.png","alt":_vm.$t('message.pollscapeLogoText')}})]),_vm._v(" "),_c('div',{staticClass:"mdl-cell mdl-cell--7-col mdl-cell--5-col-tablet mdl-cell--3-col-phone header-text-container"},[_c('h1',[_vm._v("Pollscape")]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('message.pageSubTitle')))]),_vm._v(" "),_c('h4',[_vm._v(_vm._s(_vm.$t('message.pollscapeDesc')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[(_vm.userLocale === 'hi')?_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.app.pollscape.release&utm_source=web&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"}},[_c('img',{staticClass:"fade-in",attrs:{"width":"200","height":"77","alt":"Google Play पर पाएं","src":"static/img/google-play-badge-hi.png"}})]):_vm._e(),_vm._v(" "),(_vm.userLocale === 'en')?_c('a',{attrs:{"href":"https://play.google.com/store/apps/details?id=com.app.pollscape.release&utm_source=web&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"}},[_c('img',{staticClass:"fade-in",attrs:{"width":"200","height":"77","alt":"Get it on Google Play","src":"static/img/google-play-badge-en.png"}})]):_vm._e()])])]),_vm._v(" "),_c('footer-component',{attrs:{"userLang":_vm.userLocale}}),_vm._v(" "),_c('cookie-policy-banner',{attrs:{"userLang":_vm.userLocale}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.1c2ffc9a7b6e1850d500.js